module.exports = __webpack_public_path__ + "assets/img/bg_block_03_large.843e931b.png";